import { defineCustomElement, h } from 'vue'
import VideoComponent from './VideoComponent.vue'
import css from './video-element.styles.scss?inline'

const VideoElement = defineCustomElement({
  props: VideoComponent.props,
  styles: [css],
  setup(props) {
    return () => h(VideoComponent, props as any)
  },
})

if (!customElements.get('video-element')) {
  customElements.define('video-element', VideoElement)
}
